import {createContext} from 'react';

export type AIFilterSearchContextType = {
    isLoading: boolean;
    hasError: boolean;
    isEmptyResult: boolean;
    aiSearchVisible: boolean;
};

export const defaultAIFilterSearchContext: AIFilterSearchContextType = {
    isLoading: false,
    hasError: false,
    isEmptyResult: false,
    aiSearchVisible: false
};

export const AIFilterSearchContext = createContext<AIFilterSearchContextType>(
    defaultAIFilterSearchContext
);
